import React from "react"
import { Card, CardMedia, CardContent, Typography, Box, IconButton, TextField, Tooltip } from "@mui/material"
import AddIcon from "@mui/icons-material/Add"
import RemoveIcon from "@mui/icons-material/Remove"
import InventoryIcon from "@mui/icons-material/Inventory"

const ProductoCard = ({ producto, cantidadEnCarrito, onUpdateCantidad }) => {
  // Si tenemos Base64, armamos el Data URI; de lo contrario, mostramos un placeholder genérico
  const imageSrc = producto.imagen_b64
    ? `data:image/jpeg;base64,${producto.imagen_b64}`
    : "https://via.placeholder.com/300x300?text=Sin+Imagen"

  const handleIncrement = () => {
    onUpdateCantidad(producto, cantidadEnCarrito + 1)
  }

  const handleDecrement = () => {
    if (cantidadEnCarrito > 0) {
      onUpdateCantidad(producto, cantidadEnCarrito - 1)
    }
  }

  const handleChange = (e) => {
    const val = parseInt(e.target.value, 10)
    if (!isNaN(val) && val >= 0) {
      onUpdateCantidad(producto, val)
    } else if (e.target.value === "") {
      onUpdateCantidad(producto, 0)
    }
  }

  return (
    <Card
      elevation={cantidadEnCarrito > 0 ? 6 : 1}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "all 0.3s ease",
        border: cantidadEnCarrito > 0 ? "2px solid #196C87" : "2px solid transparent",
        "&:hover": {
          boxShadow: 6,
          transform: "translateY(-4px)",
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        <CardMedia
          component="img"
          height="180"
          image={imageSrc}
          alt={producto.artdescri}
          sx={{ objectFit: "contain", p: 2, bgcolor: "#f9f9f9" }}
        />
        {cantidadEnCarrito > 0 && (
          <Box
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              bgcolor: "error.main",
              color: "white",
              fontWeight: "bold",
              borderRadius: "50%",
              width: 30,
              height: 30,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: 2,
            }}
          >
            {cantidadEnCarrito}
          </Box>
        )}
      </Box>

      <CardContent sx={{ flexGrow: 1, pb: 1 }}>
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5, fontWeight: "bold" }}>
          Cód: {producto.artcodigo}
        </Typography>
        <Tooltip title={producto.artdescri}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
              lineHeight: 1.2,
              mb: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {producto.artdescri}
          </Typography>
        </Tooltip>

        <Box display="flex" alignItems="center" gap={1} color="text.secondary" mb={2}>
          <InventoryIcon fontSize="small" />
          <Typography variant="body2" fontWeight="bold">
            Stock en Bodega: {producto.stock_actual}
          </Typography>
        </Box>
      </CardContent>

      <Box sx={{ p: 2, pt: 0, mt: "auto" }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          bgcolor="#f5f7fa"
          borderRadius={2}
          p={0.5}
        >
          <IconButton color="primary" onClick={handleDecrement} disabled={cantidadEnCarrito <= 0}>
            <RemoveIcon />
          </IconButton>

          <TextField
            variant="standard"
            value={cantidadEnCarrito === 0 ? "" : cantidadEnCarrito}
            onChange={handleChange}
            placeholder="0"
            inputProps={{
              min: 0,
              style: { textAlign: "center", fontWeight: "bold", fontSize: "1.1rem" },
            }}
            InputProps={{ disableUnderline: true }}
            sx={{ width: "50px" }}
          />

          <IconButton color="primary" onClick={handleIncrement}>
            <AddIcon />
          </IconButton>
        </Box>
      </Box>
    </Card>
  )
}

export default ProductoCard
